declare global {
  interface Navigator {
    standalone?: boolean;
  }

  interface Window {
    __hgViewportHeightShim?: {
      refresh: () => void;
    };
  }
}

const DEFAULT_VIEWPORT_HEIGHT = '100dvh';
const IOS_STANDALONE_VIEWPORT_HEIGHT = '100vh';

function isAppleMobileDevice() {
  return /iPhone|iPad|iPod/.test(window.navigator.userAgent)
    || (window.navigator.platform === 'MacIntel' && window.navigator.maxTouchPoints > 1);
}

function isIosStandalonePwa() {
  return isAppleMobileDevice() && window.navigator.standalone === true;
}

function setViewportVars(value: string) {
  const root = document.documentElement;
  root.style.setProperty('--app-height', value);
  root.style.setProperty('--app-min-height', value);
}

function setDefaultViewportVars() {
  document.documentElement.removeAttribute('data-ios-standalone-pwa');
  setViewportVars(DEFAULT_VIEWPORT_HEIGHT);
}

export function installViewportHeightShim() {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  if (window.__hgViewportHeightShim) {
    window.__hgViewportHeightShim.refresh();
    return;
  }

  const refresh = () => {
    if (!isIosStandalonePwa()) {
      setDefaultViewportVars();
      return;
    }

    // WebKit standalone PWAs can report unstable measured heights on first
    // launch. Use CSS `100vh` specifically for installed iPhone/iPad PWAs and
    // keep every other environment on the normal dynamic viewport path.
    document.documentElement.setAttribute('data-ios-standalone-pwa', 'true');
    setViewportVars(IOS_STANDALONE_VIEWPORT_HEIGHT);
  };

  window.__hgViewportHeightShim = { refresh };
  refresh();

  // Re-apply the standalone flag after lifecycle transitions. The CSS unit
  // itself (`100vh`) resolves natively; these listeners only keep the mode
  // detection current after restores / rotations.
  window.addEventListener('resize', refresh, { passive: true });
  window.addEventListener('orientationchange', refresh, { passive: true });
  window.addEventListener('pageshow', refresh, { passive: true });
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') refresh();
  });
}
